var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getAutomation } from '@citrus/runtime';
import { CharacterCount as CharacterCountElm } from './Input.styled';
import { useCharacterCountContext } from './private/context';
var CharacterCount = function (_a) {
    var automationId = _a.automationId, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.max, max = _c === void 0 ? 0 : _c, css = _a.css, _d = _a.__TYPE, __TYPE = _d === void 0 ? 'CharacterCount' : _d, other = __rest(_a, ["automationId", "text", "max", "css", "__TYPE"]);
    var context = useCharacterCountContext();
    var count = text ? text.split('').length : 0;
    var textLimit = max >= 0;
    var plural = !((!textLimit && count === 1) || (textLimit && count === max - 1));
    // FIXME: change this into functions
    // eslint-disable-next-line no-nested-ternary
    var charCountCompile = "".concat(!textLimit ? count : max - count < 0 ? 0 : max - count).concat(!textLimit ? '' : "/".concat(max), " ").concat(plural ? context.characters : context.character).concat(!textLimit ? '' : ' ' + context.remaining);
    return (React.createElement(CharacterCountElm, __assign({ style: __assign({}, css) }, getAutomation(automationId, 'remainingCharacter'), other), charCountCompile));
};
CharacterCount.defaultProps = {
    __TYPE: 'CharacterCount',
};
export default CharacterCount;
